module.exports = __webpack_public_path__ + "img/f5.5844199a.png";